/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} History_Transfer_Choice_LabelInputs */

const en_us2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercise for ${i?.name}`)
};

const pt_br2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercício para ${i?.name}`)
};

const es_419_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ejercicio para ${i?.name}`)
};

const pt_pt2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercício para ${i?.name}`)
};

const fr_fr2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercice pour ${i?.name}`)
};

const de_de2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übung für ${i?.name}`)
};

const it_it2_history_transfer_choice_label = /** @type {(inputs: History_Transfer_Choice_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esercizio per ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Exercise for {name}" |
*
* @param {History_Transfer_Choice_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_choice_label = /** @type {((inputs: History_Transfer_Choice_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Choice_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_choice_label(inputs)
	if (locale === "es-419") return es_419_history_transfer_choice_label(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_choice_label(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_choice_label(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_choice_label(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_choice_label(inputs)
	return en_us2_history_transfer_choice_label(inputs)
});
export { history_transfer_choice_label as "history-transfer.choice_label" }